import { render } from "./QuestionTypeTable.vue?vue&type=template&id=26db116e&scoped=true"
import script from "./QuestionTypeTable.vue?vue&type=script&lang=js"
export * from "./QuestionTypeTable.vue?vue&type=script&lang=js"

import "./QuestionTypeTable.vue?vue&type=style&index=0&id=26db116e&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26db116e"]])

export default __exports__